"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveJSON = exports.getJSON = exports.StorageKeys = void 0;
// 非必要不修改
var StorageKeys;
(function (StorageKeys) {
    StorageKeys["collapsed"] = "global.collapsed";
    StorageKeys["user"] = "global.user";
    StorageKeys["permission"] = "global.permission";
    StorageKeys["menu"] = "global.menu";
})(StorageKeys = exports.StorageKeys || (exports.StorageKeys = {}));
var getJSON = function (key, defaultValue) {
    try {
        return JSON.parse(localStorage.getItem(key));
    }
    catch (_a) {
        return defaultValue;
    }
};
exports.getJSON = getJSON;
var saveJSON = function (key, value) {
    localStorage.setItem(key, JSON.stringify(value));
};
exports.saveJSON = saveJSON;
